import { render, staticRenderFns } from "./gc-field-checkbox.vue?vue&type=template&id=6a4c015e"
import script from "./gc-field-checkbox.vue?vue&type=script&lang=js"
export * from "./gc-field-checkbox.vue?vue&type=script&lang=js"
import style0 from "./gc-field-checkbox.vue?vue&type=style&index=0&id=6a4c015e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports